import { render, staticRenderFns } from "./ProgramOfStartSection.vue?vue&type=template&id=5ad0df8e&scoped=true&"
import script from "./ProgramOfStartSection.vue?vue&type=script&lang=js&"
export * from "./ProgramOfStartSection.vue?vue&type=script&lang=js&"
import style0 from "./ProgramOfStartSection.vue?vue&type=style&index=0&id=5ad0df8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad0df8e",
  null
  
)

export default component.exports